module.exports = __webpack_public_path__ + "static/media/high-fid-5.2c76ea1b.svg";